import ElementPlus from 'element-plus'
import { lang } from './i18n'

import ja from 'element-plus/es/locale/lang/ja'
import ko from 'element-plus/es/locale/lang/ko'
import en from 'element-plus/es/locale/lang/en'
import { Language } from 'element-plus/lib/locale'

// 自定义时间选择器中weeks的翻译
const CustomKODatePickerWeeks = {
  sun: '일요일',
  mon: '월요일',
  tue: '화요일',
  wed: '수요일',
  thu: '목요일',
  fri: '금요일',
  sat: '토요일'
}

const dict: Record<string, Language> = {
  ja,
  ko: Object.assign(ko, {
    el: {
      ...ko.el,
      datepicker: {
        ...ko.el.datepicker,
        weeks: CustomKODatePickerWeeks
      }
    }
  }),
  en: Object.assign(ko, {
    el: {
      ...en.el,
      pagination: {
        ...en.el.pagination,
        pagesize: 'Page'
      }
    }
  })
}

export default (app:any) => {
  const locale = dict[lang]
  app.use(ElementPlus, { locale })
}
export const wrap = () => {
  const locale = dict[lang]
  return Promise.resolve(locale).then((res: Language) => {
    return (app: any) => {
      app.use(ElementPlus, {
        locale: res
      })
    }
  })
}
